import { render, staticRenderFns } from "./SingleParent.vue?vue&type=template&id=6d4030e7&scoped=true&"
import script from "./SingleParent.vue?vue&type=script&lang=ts&"
export * from "./SingleParent.vue?vue&type=script&lang=ts&"
import style0 from "./SingleParent.vue?vue&type=style&index=0&id=6d4030e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4030e7",
  null
  
)

export default component.exports